import { t as i18n } from "../i18n";

export default function ControlModal({
	theme,
	language,
	filters,
	onToggleLine,
	areAllSelected,
	onToggleAll,
	onClose,
}) {
	const isDark = theme === "dark";
	const central = i18n(language);
	const T = {
		purpleLine: central.purpleLine,
		yellowLine: central.yellowLine,
		greenLine: central.greenLine,
		showAll: central.showAll,
		hideAll: central.hideAll,
		comingSoon: central.comingSoon,
		controls: central.controls,
	};

	const chip = (bg) => ({
		display: "inline-block",
		width: 12,
		height: 12,
		borderRadius: "50%",
		background: bg,
		flexShrink: 0,
	});

	const card = {
		display: "flex",
		alignItems: "center",
		justifyContent: "space-between",
		gap: "8px",
		padding: "10px 12px",
		borderRadius: "8px",
		border: isDark ? "1px solid #333" : "1px solid #ddd",
		background: isDark ? "#222" : "#fafafa",
		cursor: "pointer",
		marginBottom: "8px",
	};

	const disabledCard = {
		...card,
		opacity: 0.6,
		cursor: "not-allowed",
	};

	return (
		<div
			onClick={(e) => e.stopPropagation()}
			style={{
				background: isDark ? "#1f1f1f" : "#fff",
				color: isDark ? "#fff" : "#111",
				padding: 20,
				borderRadius: 12,
				minWidth: 280,
				position: "relative",
				boxShadow: "0 0 12px rgba(0,0,0,0.3)",
			}}
		>
			{/* Header */}
			<h4 style={{ marginTop: 0, marginBottom: 16, textAlign: "center" }}>
				{T.controls}
			</h4>

			{/* Purple line */}
			<label style={card}>
				<div style={{ display: "flex", alignItems: "center", gap: 8 }}>
					<span style={chip("#800080")} />
					<span>{T.purpleLine}</span>
				</div>
				<input
					disabled={true}
					type="checkbox"
					checked={filters.purple}
					onChange={() => onToggleLine("purple")}
				/>
			</label>

			{/* Green line  */}
			<label style={card}>
				<div style={{ display: "flex", alignItems: "center", gap: 8 }}>
					<span style={chip("#16A34A")} />
					<span>{T.greenLine}</span>
				</div>
				<input
					disabled={true}
					type="checkbox"
					checked={filters.green}
					onChange={() => onToggleLine("green")}
				/>
			</label>

			{/* Yellow line */}
			<label style={card}>
				<div style={{ display: "flex", alignItems: "center", gap: 8 }}>
					<span style={chip("#EAB308")} />
					<span>{T.yellowLine}</span>
				</div>
				<input
					type="checkbox"
					checked={filters.yellow}
					onChange={() => onToggleLine("yellow")}
				/>
			</label>

			{/* Show/Hide All */}
			<label style={card}>
				<span>{areAllSelected ? T.hideAll : T.showAll}</span>
				<input
					type="checkbox"
					checked={areAllSelected}
					onChange={onToggleAll}
				/>
			</label>

			{/* Close button */}
			<button
				onClick={onClose}
				style={{
					marginTop: 12,
					width: "100%",
					padding: "8px",
					background: isDark ? "#333" : "#1976d2",
					color: "#fff",
					border: "none",
					borderRadius: 8,
					cursor: "pointer",
				}}
			>
				Close
			</button>
		</div>
	);
}
